<template>
    <div class="sc__analysis__tab__box tab-content">
        <div class="sc__analysis__head__box">
            <div class="title__box">
                <div class="head__title__group">
                    <div class="rlms-flex rlms-items-center rlms-gap-10">
                        <h3 class="title">Information</h3>
                        <div class="video__info__btn__item transcription-setting" style="padding: 0;">
                            <a href="https://www.youtube.com/watch?v=jEuJvNuvSjA" target="_blank" rel="noopener" class="popup-youtube rlms-flex rlms-items-center" @click="showVideoTutorial = true">
                                <span class="badge rlms-fw-600 rlms-flex rlms-items-center rlms-gap-5"><span class="material-symbols-outlined">help</span> Help</span>
                            </a>
                        </div>
                    </div>
                    <p>Welcome to the EESAPP Work Packet</p>
                </div>
                <div class="print__data__btn">
                    <WorkpacketPdf :button-label="`Download`" :assessmentId="assessmentId"
                        :organizationId="organizationId" :learnerId="learnerId"
                        v-if="assessmentId && organizationId && learnerId" />
                </div>
            </div>
        </div>
        <div class="information__content__box__wrapper">
            <div class="content__group__box">
                <div class="information__img__box">
                    <img :src="informationImg" />
                </div>
                <div class="information__text__wrapper">
                    <h6 class="title">Early Echoic Skills Assessment (EESA) Work Packet!</h6>
                    <div class="text__wrapper">
                        <p>
                            This packet is designed to support learners in developing their early echoic
                            skills, which are essential for language acquisition and verbal behavior.
                            Through
                            a structured and systematic approach, the EESA Program Planner and Protocol aim
                            to assess, enhance, and track the progress of these skills, providing a solid
                            foundation for further language development.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import WorkpacketPdf from './WorkpacketPdf.vue';
import informationImg from '@/assets/images/information-img.png';
import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import { onMounted } from 'vue';

defineProps({
    organizationId: Number,
    assessmentId: Number,
    learnerId: Number,
});

onMounted(() => {
    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
});
</script>